<template>
    <div
        v-editable="blok.text"
        class="article__text"
        v-html="renderRichText(blok.text, { schema: tocSchema })"
    />
</template>

<script setup>
import { RichTextSchema } from '@storyblok/vue'
import { tocHeadingResolver } from '#shared/articleHeadings'
import storyblokImageSize from '~/helpers/storyblokImageSize'

defineProps({
    blok: {
        type: Object,
        default: () => ({}),
    },
})

// The default image node renders a bare <img> with no dimensions. So rich-text images
// reflow the page as they load, which adds layout shift. Read the intrinsic size from the
// Storyblok asset URL and set width and height. The browser then reserves the space before
// the image loads.
function imageResolver(node) {
    const attrs = node.attrs ?? {}
    const dims = storyblokImageSize(attrs.src)
    return {
        singleTag: [{
            tag: 'img',
            attrs: {
                src: attrs.src,
                alt: attrs.alt,
                title: attrs.title,
                ...(dims ?? {}),
            },
        }],
    }
}

// renderRichText's heading resolver turns the server-stamped h2/h3 ids into anchors for
// the TOC; every other node/mark renders exactly as before.
const tocSchema = {
    nodes: { ...RichTextSchema.nodes, heading: tocHeadingResolver, image: imageResolver },
    marks: RichTextSchema.marks,
}
</script>
